import React, { useState } from 'react';

const ExamplesGallery = () => {
  const [activeCategory, setActiveCategory] = useState('all');

  const categories = [
    { id: 'all', name: 'All Examples' },
    { id: 'product', name: 'Product' },
    { id: 'portrait', name: 'Portrait' },
    { id: 'fashion', name: 'Fashion' },
    { id: 'vehicle', name: 'Car Dealerships' },
    { id: 'logo', name: 'Logo Design' },
    { id: 'material', name: 'Creative Materials' },
    { id: 'social', name: 'Social Media' }
  ];

  const examples = [
    {
      id: 1,
      category: 'product',
      title: "E-commerce Product Photography",
      before: "/examples/product-1-before.jpg",
      after: "/examples/product-1-after.png",
      description: "Perfect product detail presentation for higher conversion rates"
    },
    {
      id: 2,
      category: 'portrait',
      title: "Professional Portrait Photos",
      before: "/examples/portrait-1-before.jpg",
      after: "/examples/portrait-1-after.png",
      description: "Perfect for social media and professional profiles"
    },
    {
      id: 3,
      category: 'fashion',
      title: "Fashion Style Showcase",
      before: "/examples/fashion-1-before.jpg",
      after: "/examples/fashion-1-after.png",
      description: "Enhance visual impact of clothing and accessories"
    },
    {
      id: 4,
      category: 'vehicle',
      title: "Automotive Photography",
      before: "/examples/vehicle-1-before.jpg",
      after: "/examples/vehicle-1-after.png",
      description: "Create stunning vehicle presentations"
    },
    {
      id: 5,
      category: 'product',
      title: "Jewelry Photography",
      before: "/examples/product-2-before.jpg",
      after: "/examples/product-2-after.png",
      description: "Highlight jewelry details and textures"
    },
    {
      id: 7,
      category: 'logo',
      title: "Logo Design",
      before: "/examples/logo-1-before.jpg",
      after: "/examples/logo-1-after.png",
      description: "Professional logo extraction for branding"
    },
    {
      id: 9,
      category: 'material',
      title: "Creative Graphics",
      before: "/examples/material-1-before.jpg",
      after: "/examples/material-1-after.png",
      description: "Extract design elements for creative projects"
    },
    {
      id: 10,
      category: 'material',
      title: "Icon Design",
      before: "/examples/material-2-before.jpg",
      after: "/examples/material-2-after.png",
      description: "Clean icon extraction for UI/UX design"
    },
    {
      id: 11,
      category: 'social',
      title: "Instagram or YouTube Posts",
      before: "/examples/social-1-before.jpg",
      after: "/examples/social-1-after.png",
      description: "Create eye-catching social media content"
    }
  ];

  const filteredExamples = activeCategory === 'all' 
    ? examples 
    : examples.filter(example => example.category === activeCategory);

  return (
    <section id="examples" className="py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-3xl font-extrabold bg-gradient-to-r from-blue-600 to-blue-800 bg-clip-text text-transparent sm:text-4xl">
            AI Background Removal Showcase
          </h2>
          <p className="mt-4 max-w-2xl mx-auto text-xl text-gray-500">
            Perfect background removal for every scenario
          </p>
        </div>

        {/* Category Filters */}
        <div className="mt-12 flex justify-center space-x-4">
          {categories.map((category) => (
            <button
              key={category.id}
              onClick={() => setActiveCategory(category.id)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300
                ${activeCategory === category.id
                  ? 'bg-blue-600 text-white shadow-md'
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}`}
            >
              {category.name}
            </button>
          ))}
        </div>
        
        {/* Examples Grid */}
        <div className="mt-12 grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {filteredExamples.map((example) => (
            <div
              key={example.id}
              className="rounded-xl overflow-hidden shadow-sm hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1 bg-blue-50/50"
            >
              {/* Before/After Comparison */}
              <div className="relative h-[192px]">
                <div className="absolute inset-0 flex">
                  <div className="w-1/2 relative overflow-hidden">
                    <img
                      src={example.before}
                      alt={`${example.title} - before`}
                      className="absolute inset-0 w-full h-full object-cover"
                    />
                    <div className="absolute top-4 left-4 bg-black/50 backdrop-blur-md text-white px-3 py-1 rounded-full text-sm">
                      Before
                    </div>
                  </div>
                  <div className="w-1/2 relative overflow-hidden">
                    {/* 使用CSS绘制透明背景网格 */}
                    <div className="absolute inset-0 png-grid-bg"/>
                    <img
                      src={example.after}
                      alt={`${example.title} - after`}
                      className="absolute inset-0 w-full h-full object-cover"
                    />
                    <div className="absolute top-4 right-4 bg-blue-600/90 backdrop-blur-md text-white px-3 py-1 rounded-full text-sm">
                      After
                    </div>
                  </div>
                </div>
              </div>

              {/* Example Info */}
              <div className="p-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  {example.title}
                </h3>
                <p className="text-gray-600">
                  {example.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ExamplesGallery;